import { GetHistoryParams, UploadRecordingParams } from "../../types/goal";

const ZYVELOR_AI_API_URL = process.env.REACT_APP_ZYVELOR_AI_API_URL;
const ZYVELOR_AI_API_KEY = process.env.REACT_APP_ZYVELOR_AI_API_KEY;

type APIOptions = {
  payload?: any;
  method?: string;
  params?: any;
};

export const makeAPIRequest = async (url: string, {payload, method = "GET", params}: APIOptions) => {
  const apiUrl = new URL(`${ZYVELOR_AI_API_URL}${url}`);
  const headers = new Headers({
    "x-api-key": ZYVELOR_AI_API_KEY ?? "",
    "Content-Type": "application/json",
  });

    // Append all payload properties as query parameters
    if (params && typeof params === "object") {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null) {
          apiUrl.searchParams.append(key, params[key].toString());
        }
      });
    }

    return fetch(apiUrl.toString(), {
      method: method,
      headers: headers,
      body: payload ? JSON.stringify(payload) : undefined,
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error fetching AI assessments done:", error);
        throw error;
      });
}

// Function to generate diet plan using AI
export const generateAIDietPlan = async (patientProfileData: any) => {
  return makeAPIRequest('/indian-diet-plan/generate', {
    method: 'POST',
    params: { processing_mode: 'background' },
    payload: {
      patient_profile_v0: patientProfileData
    }
  });
}

export const uploadAssessmentRecording = async (params: UploadRecordingParams) => {
  return makeAPIRequest("/zoom/recordings", {
    method: "GET",
    params,
  });
};

export const getAssessmentRecordingHistory = async (params: GetHistoryParams) => {
  return makeAPIRequest("/zoom/recordings/history", {
    method: "GET",
    params: {
      patient_id: params.patient_id,
    },
  });
};
